export const tabUrlMap = {
	"docs/": {
		index: 0,
		customColumnsKey: "/documents",
		breadcrumbsIcon: "file",
		selectionListName: "selectedDocuments",
		backendRoot: "/document",
		itemNoun: "documents",
	},
	"email/": {
		index: 1,
		customColumnsKey: "/email",
		breadcrumbsIcon: "envelope",
		selectionListName: "selectedEmails",
		backendRoot: "/email",
		itemNoun: "emails",
	},
	"notes/": {
		index: 2,
		customColumnsKey: "/notes",
		breadcrumbsIcon: "pencil-alt",
		selectionListName: "selectedNotes",
		backendRoot: "/notes",
		itemNoun: "notes",
	},
	"ai/": {
		index: 3,
		customColumnsKey: "/ai",
		breadcrumbsIcon: "sparkles",
		selectionListName: "selectedAIMessages",
		backendRoot: "/ai",
		itemNoun: "AI messages",
	},
	"sharing/": {
		index: 4,
		customColumnsKey: "/sharing",
		breadcrumbsIcon: "pencil-alt",
		selectionListName: "selectedNotes",
		backendRoot: "/notes",
		itemNoun: "notes",
	},
	"archive/": {
		index: 5,
		customColumnsKey: "/archive",
		breadcrumbsIcon: "archive",
		selectionListName: "selectedArchiveDocuments",
		backendRoot: "/document",
		itemNoun: "documents",
	},
	"trash/": {
		index: 6,
		customColumnsKey: "/trash",
		breadcrumbsIcon: "trash",
		selectionListName: "selectedTrashDocuments",
		backendRoot: "/document",
		itemNoun: "documents",
	},
	"public/": {
		index: -1,
		customColumnsKey: "/documents",
		breadcrumbsIcon: "file",
		selectionListName: "selectedPublicDocuments",
		backendRoot: "/document",
		itemNoun: "documents",
	},
	"private/": {
		index: -1,
		customColumnsKey: "/documents",
		breadcrumbsIcon: "file",
		selectionListName: "selectedPrivateDocuments",
		backendRoot: "/document",
		itemNoun: "documents",
	},
};
